const green = 'rgb(51, 164, 104)'; // #33A468
const orange = 'rgb(223, 121, 52)'; // #DF7934
const orange2 = 'rgb(224, 124, 57)'; // #E07C39
const red = 'rgb(210, 38, 48)'; //#D22630
const white = 'rgb(255, 255, 255)'; // #FFFFFF
const black = 'rgb(0, 0, 0)'; // #000000
const lightBlue = 'rgb(137,209,212)'; //#89D1D4
const blue = 'rgb(29,156,211)'; //#1d9cd3
const purple = 'rgb(94, 32, 160)'; // #5E20A0
const purple2 = 'rgb(75, 25, 128)'; // #4b1980
const grey = 'rgb(204,204,204)'; //#CCCCCC
const grey2 = 'rgb(136,136,136)'; //#888888
const grey3 = 'rgb(153,153,153)'; //#999999
const lightGray = 'rgb(244, 244, 244)'; // #F4F4F4
const lightGray2 = 'rgb(238, 238, 238)'; // #EEEEEE
const lightGray3 = 'rgb(237, 237, 237)'; // ##EDEDED
const darkGrey = 'rgb(118,118,118)'; // #767676
const darkGrey2 = 'rgb(68, 68, 68)'; // #444444
const disabledTextGrey = 'rgb(170,170,170)' //#AAAAAA

const transparentGreen = 'rgba(51, 164, 104, 0.1)'; // #33A468
const transparentOrange = 'rgba(223, 121, 52, 0.1)'; // #DF7934
const transparentDarkGrey = 'rgb(118,118,118, 0.5)'; // #767676
const transparentPurple = 'rgba(94, 32, 160, 0.25)'; // #5E20A0

/**
 * Common color palette for CMS UI
 */
const cmsColors = {
  confirmColor: green,
  confirmBackground: transparentGreen,
  alertColor: orange,
  alertColorLight: orange2,
  alertBackground: transparentOrange,
  backgroundGray: lightGray,
  lightGray2,
  lightGray3,
  green,
  white,
  black,
  lightBlue,
  blue,
  purple,
  purple2,
  transparentPurple,
  grey,
  grey2,
  grey3,
  darkGrey,
  darkGrey2,
  transparentDarkGrey,
  disabledTextGrey,
  red
};

/**
 * Device breakpoints
 */
const breakpoints = {
  mobile: 512,
  tablet: 768,
  smallScreen: 1024,
  desktop: 1200
};

/**
 * Customer Success Specialists (CSS) email for directing "contact us" type emails
 */
const cssEmailAddress = 'csssales@edlio.com';

export {
  breakpoints,
  cmsColors,
  cssEmailAddress
};



// WEBPACK FOOTER //
// ./src/main/webapps/common/edlio-js/constants/index.js